import React from 'react';
import styled, { css } from 'styled-components';
import Paragraph from '../../collections/Paragraph/Paragraph';
import { media } from '../../utilities/style-utilities';
import { fontUbuntuLight } from '../../utilities/utilities';
// import { remy } from '../../utilities/utilities';

const ContentInner = styled.div`
  display: flex;
  flex-direction: ${props => props.column ? 'column' : 'row'};
  align-items:center;
`;

const ContentInnerColumn = styled.div`
  display: flex;
  flex-direction: ${props => props.column ? 'column-reverse' : 'row'};
`;

const ContentColLeft = styled.div`
  flex: 1 1 50%;
  -webkit-flex: 1 1 auto; /* Safari 6.1+ */
  -ms-flex: 1 1 auto; /* IE 11- */
  display: flex;
  display: -ms-flexbox;
  flex-direction: column;
  align-items: center;
`;

const ContentColRight = styled.div`
  flex: 1 1 44%;
  -webkit-flex: 1 1 auto; /* Safari 6.1+ */
  -ms-flex: 1 1 auto; /* IE 11- */
  display: flex;
  display: -ms-flexbox;
  display: -ms-flexbox;
  flex-direction: column;
  align-items: center;
`;

const ContentParagraph = styled(Paragraph)`
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  text-align: center;
  font-size: 1.05em;
  max-width: ${ props => props.maxWidth};
  font-weight: ${ props => props.fontWeight};
  margin-bottom: ${ props => props.marginBottom};

  ${ props => props.margin && css`
    line-height: 1.4rem;
    margin: 1.4rem 0;
  `} 
`;

// const AmountBox = styled.div`
//   display: flex;
//   justify-content: center;
//   background-color: #f7f7f7;
//   border: 1px solid #e6e6e6;
//   padding: 0.75rem 1rem 0.75rem 1rem;
//   max-width: 290px;
//   width:100%;
//   margin: 0 auto;
// `;

// const Amount = styled.span`
//   font-size: 3em;
//   color: #0d1b58;
//   font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntu};
//   background-color: #ffffff;
//   border: 1px solid #e6e6e6;
//   padding: 0.2rem;
//   flex: 1 1 auto;
//   text-align: center;
// `

const Retailers = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  /* background-color: gray; */
  margin: 0 1rem;
  max-width: 100%;
  width:100%;
  padding-bottom: 1.5rem;
  /* ${ media.desktop`
    max-width: 500px;
  `} */
`;

const Offers = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const DealsOffers = (props) => {
  return(
    <ContentInner column>

      <ContentInnerColumn column>
        <ContentColLeft>
            <ContentParagraph fontWeight={'bold'} marginBottom={'0'}>To start shopping, redeem your money online by clicking on any of the retailers below</ContentParagraph>
            <ContentParagraph maxWidth={'80%'} margin>You can also use your prepaid Mastercard at over 38 million locations worldwide</ContentParagraph>
            <Retailers>
            {props.retailers}
            </Retailers>
        </ContentColLeft>
        <ContentColRight>
            <ContentParagraph>Special offers</ContentParagraph>
            <Offers>
            {props.offers}
            </Offers>
        </ContentColRight>
      </ ContentInnerColumn>
    </ContentInner>
  );
}

export default DealsOffers;


// WEBPACK FOOTER //
// ./src/containers/Deals/DealsOffers.js